'use strict';

module.exports = function () {
    $(document).ready(function () {
        var banner = document.getElementById('header-banner-mobile-app');
        var root = document.documentElement;

        // The custom content-slot banner positions itself. Only measure the
        // Mapp version, which does not contain the slot banner's close button.
        if (!banner || banner.querySelector('.header-banner-m__close')) {
            return;
        }

        function updateBannerHeight() {
            var height = Math.max(0, Math.ceil(banner.getBoundingClientRect().height) - 1);
            root.style.setProperty('--mapp-mobile-banner-height', height + 'px');
        }

        // Mapp may inject the markup after page load; observe both content
        // changes and intrinsic size changes (for example, when its image loads).
        if (window.ResizeObserver) {
            var resizeObserver = new ResizeObserver(updateBannerHeight);
            resizeObserver.observe(banner);
        }

        var mutationObserver = new MutationObserver(updateBannerHeight);
        mutationObserver.observe(banner, {
            childList: true,
            subtree: true,
            attributes: true
        });

        window.addEventListener('resize', updateBannerHeight);
        banner.addEventListener('load', updateBannerHeight, true);
        updateBannerHeight();
    });
};
